// extracted by mini-css-extract-plugin
export var fullWidthButton = "_px-0";